<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Schedule"
              icon="fas fa-list">
            </card-section-header>

            <div class="mb-2 animated fadeIn">
              <div class="d-flex justify-content-end">
                <button type="button" [disabled]="!pendingItems.length && !cancelledItems.length" class="btn btn-primary btn-link" (click)="viewPendingList()">view {{cancelledItems.length + pendingItems.length}} pending items</button>
              </div>

              <scheduler-filters [initialDate]="initialDate" (filtersChanged)="onFiltersChanged($event)"></scheduler-filters>

              <div *ngIf="!response" style="width: 50px; margin: 0 auto">
                <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
              </div>

              <ng-container *ngIf="response">
                <scheduler
                    [hoursPerColumn]="hoursPerColumn"
                    [siteId]="response.id"
                    [assetsAndSchedules]="response.assets"
                    [start]="startTime"
                    [end]="endTime"
                    (gridClick)="onGridClick($event)"
                    (bookingClick)="onBookingClick($event)"
                ></scheduler>
                <br>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
